export const ASSET_NAME = 'terms-of-service';

// Container Trader: the Terms of Service page is built in code, so it no longer needs the
// Console page asset.
export const loadData = () => () => Promise.resolve();
